/* eslint-disable no-underscore-dangle */
import React, {
  memo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

const defaultRecord = () => ({
  year: new Date().getFullYear(),
});

function AnimalsTablePart({
  data, options, onChange, readOnly,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage, getControlTP,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });

  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />

      <TableContainer component={Paper} sx={{ maxHeight: '60vh', overflowX: 'auto' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.year.label}
              </TableCell>
              <TableCell>
                {fields.bull.label}
              </TableCell>
              <TableCell>
                {fields.cow.label}
              </TableCell>
              <TableCell>
                {fields.heifer1_2.label}
              </TableCell>
              <TableCell>
                {fields.heifer2_ower.label}
              </TableCell>
              <TableCell>
                {fields.heifer_1.label}
              </TableCell>
              <TableCell>
                {fields.piggy9_ower.label}
              </TableCell>
              <TableCell>
                {fields.piggy4_ower.label}
              </TableCell>
              <TableCell>
                {fields.piggy_2.label}
              </TableCell>
              <TableCell>
                {fields.goat.label}
              </TableCell>
              <TableCell>
                {fields.sheep.label}
              </TableCell>
              <TableCell>
                {fields.horse3_ower.label}
              </TableCell>
              <TableCell>
                {fields.horse_1.label}
              </TableCell>
              <TableCell>
                {fields.rabbit.label}
              </TableCell>
              <TableCell>
                {fields.chikken.label}
              </TableCell>
              <TableCell>
                {fields.bee.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                getControlTP={getControlTP}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

AnimalsTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

AnimalsTablePart.defaultProps = {
  readOnly: false,
};

export default memo(AnimalsTablePart);
